import * as React from "react";
import type { SVGProps } from "react";
const SvgAirSeven = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M38.602 5.578c-.098-.137-.282-.21-.54-.21H7.875c-.602 0-.797.343-.797.788v1.227c0 .441.207.785.797.785h26.637c.43 0 .664.285.55.75l-9.667 40.098c-.122.492 0 .886.601.886h1.305c.453 0 .808-.172.933-.613L38.652 6.168c.059-.285.035-.469-.05-.59m0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1,
      }}
    />
    <path
      d="M45.95.207C45.851.074 45.663 0 45.405 0H4.965c-.602 0-.797.344-.797.785v1.23c0 .442.195.786.797.786h36.89c.43 0 .665.281.555.75L31.477 49.004c-.125.492 0 .887.601.887h1.3c.458 0 .813-.172.934-.618L45.997.785c.074-.27.05-.453-.047-.578m0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1,
      }}
    />
    <path
      d="m19.902 33.488 4.008-16.597c.059-.27.035-.442-.05-.575-.098-.136-.258-.21-.516-.21h-9.645c-.601 0-.785.343-.785.785v1.23c0 .442.184.785.785.785h6.621c.075 0 .114.012.137.051.023.035.035.086.023.16L17.066 33.22c-.125.492 0 .883.602.883h1.316c.453 0 .809-.157.918-.614m0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1,
      }}
    />
    <path
      d="M31.242 10.945c-.097-.133-.281-.207-.539-.207H10.79c-.601 0-.785.344-.785.785v1.227c0 .445.184.79.785.79h16.363c.43 0 .664.28.551.75l-8.375 34.702c-.125.492 0 .887.602.887h1.3c.454 0 .813-.172.934-.617l9.129-37.739c.059-.27.035-.453-.05-.578m0 0"
      style={{
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1,
      }}
    />
  </svg>
);
export default SvgAirSeven;
